<template>
  <div class="page">
    <div>
      <div class="title">
        <span style="font-family: fzxbsjt"><i class="el-icon-menu"
                                              style="margin-right: 10px"></i>{{ $t('home.Secretariat') }}</span>
        <div class="line"></div>
        <div>
          <div class="text" v-if="this.$i18n.locale == 'zh'">
            澜湄执法中心的决策机构为澜沧江-湄公河流域执法安全合作部长级会议，每两年举行一次会议或视情指派高级别代表召开年度会议，决定中心活动的大政方针、审议中心工作计划、报告和人事、预算等重要事项。
          </div>
          <div class="text" v-if="this.$i18n.locale == 'zh'">
            澜湄执法中心下设湄公河联合巡逻执法指挥部、情报融合与案件协查部、联合行动协调部、执法能力建设部、综合保障部。
            澜湄执法中心首席执行官为秘书长，任期为3年，负责中心日常运营，并向湄公河流域执法安全合作部长级会议报告工作。各成员国各自派1名代表担任中心副秘书长协助秘书长工作，任期为4年。秘书长和副秘书长由澜沧江-湄公河流域执法安全合作部长级会议任命。各成员国执法部门向中心秘书处派驻常驻或临时派驻官员开展工作，派驻部门、人数和轮换时间由各方协商确定。
          </div>
          <div class="text" v-if="this.$i18n.locale == 'en'">
            The decision-making body of the Law Enforcement Center is the Ministerial Conference on Law Enforcement and
            Security Cooperation in the Lancang-Mekong River Basin. It meets every two years or assigns high-level
            representatives to convene an annual meeting to decide the major policies of the center activities, the work
            plan of the review center, the report and Important matters such as personnel and budget.
          </div>
          <div class="text" v-if="this.$i18n.locale == 'en'">
            The Law Enforcement Center has a Mekong River Joint Patrol Enforcement Command, Intelligence Integration and
            Case Investigation Department, Joint Action Coordination Department, Law Enforcement Capacity Construction
            Department, and Comprehensive Security Department.
            The CEO of the Law Enforcement Center is the Secretary-General for a three-year term and is responsible for
            the day-to-day operations of the Center and reports to the Mekong River Basin Ministerial Conference on Law
            Enforcement and Security Cooperation. Each member country shall send one representative to serve as the
            Deputy Secretary-General of the Center to assist the Secretary-General for a term of four years. The
            Secretary-General and the Deputy Secretary-General were appointed by the Ministerial Conference on Law
            Enforcement and Security Cooperation in the Lancang-Mekong River Basin. The law enforcement departments of
            the member states send resident or temporary officials to the central secretariat to carry out their work.
            The number of departments, the number of people and the rotation time are determined by the parties.
          </div>
        </div>
      </div>
      <div class="title">
        <span style="font-family: fzxbsjt"><i class="el-icon-menu"
                                              style="margin-right: 10px"></i>{{ $t('home.organizational') }}</span>
        <div class="line"></div>
        <div>
          <img src="../../assets/img/组织架构.png" width="100%">
          <br>
          <!--          <div class="tree">-->
          <!--            <ul>-->
          <!--              <li>-->
          <!--                <div class="leader1-box">-->
          <!--                  <div class="leader1-box-title">代理秘书长</div>-->
          <!--                  <p>尤小文</p>-->
          <!--                  <p>YOU Xiaowen</p>-->
          <!--                  <p>China</p>-->
          <!--                </div>-->
          <!--                <ul>-->
          <!--                  <li>-->
          <!--                    <div class="leader2-box-title">副秘书长</div>-->
          <!--                    <div class="leader2-box">-->
          <!--                      <p>李大吴</p>-->
          <!--                      <p>LY Davuth</p>-->
          <!--                      <p>Cambodia</p></div>-->
          <!--                  </li>-->
          <!--                  <li>-->
          <!--                    <div class="leader2-box-title">副秘书长</div>-->
          <!--                    <div class="leader2-box">-->
          <!--                      <p>姜水</p>-->
          <!--                      <p>Jiang Shui</p>-->
          <!--                      <p>China</p></div>-->
          <!--                  </li>-->
          <!--                  <li>-->
          <!--                    <div class="leader2-box-title">副秘书长</div>-->
          <!--                    <div class="leader2-box">-->
          <!--                      <p>翁赛·潘塔翁</p>-->
          <!--                      <p style="font-size: 1.8vh">Vongxay-->
          <!--                        PHANTHAVONG</p>-->
          <!--                      <p>Laos</p></div>-->
          <!--                  </li>-->
          <!--                  <li>-->
          <!--                    <div class="leader2-box-title">副秘书长</div>-->
          <!--                    <div class="leader2-box">-->
          <!--                      <p>德瑙</p>-->
          <!--                      <p>THET Nuang</p>-->
          <!--                      <p>Myanmar</p></div>-->
          <!--                  </li>-->
          <!--                </ul>-->
          <!--              </li>-->
          <!--            </ul>-->
          <!--          </div>-->

        </div>
      </div>
      <div class="title">
        <span style="font-family: fzxbsjt"><i class="el-icon-menu" style="margin-right: 10px"></i>{{
            $t('home.leader')
          }}</span>
        <div class="line"></div>
        <div>
          <div class="leader-card" v-for="(item,index) in centralLeadershipList" :key="index">
            <div style="width: 15%;text-align: center;">
              <img :src="$urlFile + item.photo" class="img" alt="Logo" width="90%"/>
              <p class="name">{{ item.chinaName }}</p>
              <p class="name">{{ item.engName }}</p>
            </div>
            <div class="zhiWei">
              <p v-if="$i18n.locale == 'zh'">{{ item.position }}</p>
              <p v-if="$i18n.locale == 'en'">{{ item.enPosition }}</p>
              <div v-for="(item2,index2) in nationalityOption" :key="index2">
                <img v-if="item.nationality == item2.value" :src="item2.flagImg" alt="Logo" style="vertical-align: middle" width="18%">
                <p v-if="item.nationality == item2.value">{{item2.engName}}</p>
              </div>
            </div>
            <div class="leader-text" style="word-break: break-all;" v-if="$i18n.locale == 'zh'">{{ item.describe }}</div>
            <div class="leader-text" style="word-break: break-all;" v-else>{{ item.engDescribe }}</div>
          </div>
          <!-- <div class="leader-card">
            <div style="width: 15%;text-align: center;">
              <img src="../../assets/img/leader1.png" class="img" alt="Logo" width="90%"/>
              <p class="name">尤小文</p>
              <p class="name">YOU Xiaowen</p>
            </div>
            <div class="zhiWei">
              <p>代理秘书长</p>
              <img src="../../assets/img/guoqi1.png" alt="Logo" style="vertical-align: middle" width="18%">
              <p>China</p>
            </div>
            <div class="leader-text" style="">
              尤小文，男，经济学博士。<br>
              曾任中国驻加拿大使馆警务参赞，中国公安部经济犯罪侦查局副局长、一级巡视员，一级警监警衔。
            </div>

          </div>
          <div class="leader-card">
            <div style="width: 15%;text-align: center;">
              <img src="../../assets/img/leader3.png" class="img" alt="Logo" width="90%"/>
              <p class="name">姜水</p>
              <p class="name">Jiang Shui</p>
            </div>
            <div class="zhiWei">
              <p>副秘书长</p>
              <img src="../../assets/img/guoqi1.png" alt="Logo" style="vertical-align: middle" width="18%">
              <p>China</p>
            </div>
            <div class="leader-text" style="">
            </div>
          </div>
          <div class="leader-card">
            <div style="width: 15%;text-align: center;">
              <img src="../../assets/img/leader2.png" class="img" alt="Logo" width="90%"/>
              <p class="name">李大吴</p>
              <p class="name">LY Davuth</p>
            </div>
            <div class="zhiWei">
              <p>副秘书长</p>
              <img src="../../assets/img/guoqi2.png" alt="Logo" style="vertical-align: middle" width="18%">
              <p>Cambodia</p>
            </div>
            <div class="leader-text" style="">
            </div>
          </div>

          <div class="leader-card">
            <div style="width: 15%;text-align: center;">
              <img src="../../assets/img/leader4.png" class="img" alt="Logo" width="90%"/>
              <p class="name">翁赛·潘塔翁</p>
              <p class="name">Vongxay
                PHANTHAVONG</p>
            </div>
            <div class="zhiWei">
              <p>副秘书长</p>
              <img src="../../assets/img/guoqi3.png" alt="Logo" style="vertical-align: middle" width="18%">
              <p>Laos</p>
            </div>
            <div class="leader-text" style="">
              翁赛.潘塔翁，男，1969年10月出生，政治学学士。<br>
              曾任老挝国际刑警组织国家中心局主管、公安部外事局副局长、国家禁毒办副主任。
            </div>
          </div>
          <div class="leader-card">
            <div style="width: 15%;text-align: center;">
              <img src="../../assets/img/leader5.png" class="img" alt="Logo" width="90%"/>
              <p class="name">德瑙</p>
              <p class="name">THET Nuang</p>
            </div>
            <div class="zhiWei">
              <p>副秘书长</p>
              <img src="../../assets/img/guoqi4.png" alt="Logo" style="vertical-align: middle" width="18%">
              <p>Myanmar</p>
            </div>
            <div class="leader-text" style="">
            </div>
          </div> -->

        </div>
      </div>
    </div>


    <!--    <div style="padding: 5em 12% 5em 12%;">-->
    <!--    <div style="width: 40%;height: 3px;background-image: radial-gradient(circle at center, #0f7eff 0%, transparent 100%);margin: auto;margin-bottom: 0.6em;margin-top: 0.6em"></div>-->
    <!--    <div style="color: #3a8ee6;font-size: 2.5em;margin-bottom: 0.6em">{{ $t('home.organizationalStructure') }}</div>-->
    <!--    <div style="width: 40%;height: 3px;background-image: radial-gradient(circle at center, #0f7eff 0%, transparent 100%);margin: auto;margin-bottom: 0.6em"></div>-->
    <!--&lt;!&ndash;    <div style="margin-top: 0.2em;color: #3a8ee6;font-size: 2.5em">Organizational Structure</div>&ndash;&gt;-->
    <!--    <br>-->
    <!--    <div style="padding: 1em 7em 1em 7em">-->
    <!--      <div class="text" v-if="this.$i18n.locale == 'zh'">-->
    <!--        澜湄执法中心的决策机构为澜沧江-湄公河流域执法安全合作部长级会议，每两年举行一次会议或视情指派高级别代表召开年度会议，决定中心活动的大政方针、审议中心工作计划、报告和人事、预算等重要事项。-->
    <!--      </div>-->
    <!--      <div class="text" v-if="this.$i18n.locale == 'zh'">-->
    <!--        澜湄执法中心下设湄公河联合巡逻执法指挥部、情报融合与案件协查部、联合行动协调部、执法能力建设部、综合保障部。-->
    <!--        澜湄执法中心首席执行官为秘书长，任期为3年，负责中心日常运营，并向湄公河流域执法安全合作部长级会议报告工作。各成员国各自派1名代表担任中心副秘书长协助秘书长工作，任期为4年。秘书长和副秘书长由澜沧江-湄公河流域执法安全合作部长级会议任命。各成员国执法部门向中心秘书处派驻常驻或临时派驻官员开展工作，派驻部门、人数和轮换时间由各方协商确定。-->
    <!--      </div>-->
    <!--      <div class="text" v-if="this.$i18n.locale == 'en'">-->
    <!--        The decision-making body of the Law Enforcement Center is the Ministerial Conference on Law Enforcement and Security Cooperation in the Lancang-Mekong River Basin. It meets every two years or assigns high-level representatives to convene an annual meeting to decide the major policies of the center activities, the work plan of the review center, the report and Important matters such as personnel and budget.-->
    <!--      </div>-->
    <!--        <div class="text" v-if="this.$i18n.locale == 'en'">-->
    <!--        The Law Enforcement Center has a Mekong River Joint Patrol Enforcement Command, Intelligence Integration and Case Investigation Department, Joint Action Coordination Department, Law Enforcement Capacity Construction Department, and Comprehensive Security Department.-->
    <!--        The CEO of the Law Enforcement Center is the Secretary-General for a three-year term and is responsible for the day-to-day operations of the Center and reports to the Mekong River Basin Ministerial Conference on Law Enforcement and Security Cooperation. Each member country shall send one representative to serve as the Deputy Secretary-General of the Center to assist the Secretary-General for a term of four years. The Secretary-General and the Deputy Secretary-General were appointed by the Ministerial Conference on Law Enforcement and Security Cooperation in the Lancang-Mekong River Basin. The law enforcement departments of the member states send resident or temporary officials to the central secretariat to carry out their work. The number of departments, the number of people and the rotation time are determined by the parties.-->
    <!--      </div>-->
    <!--    </div>-->
    <!--    </div>-->
  </div>
</template>

<script>
  import {getLeaderIntroductionList} from '@/api/summary'
  export default {
    name: 'summary',
    components: {
        // shareDialog
    },
    data(){
        return{
          queryParams:{},
          centralLeadershipList:[],
          nationalityOption:[
            {
                label:"中国",
                value:"0",
                type:"primary",
                engName:"China",
                flagImg:require("../../assets/img/guoqi1.png"),
            },
            {
                label:"柬埔寨",
                value:"1",
                type:"primary",
                engName:"Cambodia",
                flagImg:require("../../assets/img/guoqi2.png"),
            },
            {
                label:"老挝",
                value:"2",
                type:"primary",
                engName:"Laos",
                flagImg:require("../../assets/img/guoqi3.png"),
            },
            {
                label:"泰国",
                value:"3",
                type:"primary",
                engName:"Thailand",
                flagImg:"",
            },
            {
                label:"越南",
                value:"4",
                type:"primary",
                engName:"Vietnam",
                flagImg:"",
            },
            {
                label:"缅甸",
                value:"5",
                type:"primary",
                engName:"Myanmar",
                flagImg:require("../../assets/img/guoqi4.png"),
            },
          ]
        }
    },
    created(){
    //     if(this.$i18n.locale == 'zh'){
    //         this.dataList = this.dataListZh
    //         }else if(this.$i18n.locale == 'en'){
    //         this.dataList = this.dataListEn
    //         }
    //    this.total = this.dataList.length
    },
    mounted(){
        this.getData()
    },
    methods:{
        init(){
            this.flag = false //是否为二级标题
            this.titleTree.children.forEach((item,index) => {
                    if(item.data.id == this.id){
                        this.flag = true
                    }
            });
            if(this.flag){
                this.titleTree.children.forEach((item,index) => {
                    if(item.data.id == this.id){
                        this.titleData = item
                        this.titleDataChild = this.titleData.children
                        this.queryParams.classId = item.children[0].data.id
                        this.activeIndex = 0
                    }
                });
                this.getData()
            }else{
                this.titleTree.children.forEach((item,index) => {
                    if(item.data.id == this.pid){
                        this.titleData = item
                        this.titleDataChild = this.titleData.children

                        this.queryParams.classId = this.id
                        item.children.forEach((item2,index2)=>{
                            if(item2.data.id == this.id){
                                this.activeIndex = index2

                            }
                        })
                    }
                });
                this.getData()
            }
        },
        getData(){
            // if(this.$i18n.locale == 'zh'){
            //     this.queryParams.lang="1"
            // }else{
            //     this.queryParams.lang="2"
            // }
            getLeaderIntroductionList(this.queryParams).then(res => {
                this.centralLeadershipList = res.data;
            })

        },
        shareClick(){
            this.$refs.shareDialog.open('Repost to Facebook',{})

        },
        subTitleClick(index){
            this.activeIndex = index
            this.queryParams.classId = this.titleData.children[index].data.id
            this.queryParams.index = 1
            this.queryParams.size = 10
            this.getData()
        },
        openDetail(item){
            this.$router.push({
              path: '/personDetail',
              query: {
                id:item.id,
                personStatus:this.$route.query.personStatus
              }
            })
            console.log("item",item)
        },
        /**页条数变化 */
        handleSizeChange(val){
          this.queryParams.size = val
          this.queryParams.index = 1
        //   this.pageList()
          this.getData()
        },
        /**当前页变化 */
        handleCurrentChange(val){
          this.queryParams.current = val
        //   this.pageList()

          this.getData()
        },
    }
  }
</script>


<style scoped lang="less">
@media only screen and (min-width: 800px) {
  .page {
    width: 100%;
    height: 100%;
    padding-left: 18%;
    padding-right: 18%;
    //padding-top: 80px;

    .text {
      //padding: 20px;
      text-indent: 2.4em;
      text-align: left;
      font-size: 0.8em;
      line-height: 2em;
      font-family: 微软雅黑;
      font-weight: 600;
    }

    .title {
      text-align: left;
      line-height: 1.5em;
      font-size: 2.5vh;
      font-weight: bold;
      margin-top: 60px;
    }

    .line {
      width: 100%;
      height: .6vh;
      margin: 0 auto;
      background: linear-gradient(to right,
      #678dda, /* 开始颜色 */ #6e6aec 50%, /* 在中心点附近使用过渡色 */ #678dda /* 结束颜色 */);
      margin-top: 1vh;
      margin-bottom: 1vh;
    }

    .leader-card {
      width: 100%;
      display: flex;
      border: #d5d7d7 1px solid;
      background-color: rgba(223, 224, 224, 0.29);
      padding: 5px;
      align-items: center; /* 垂直居中内容 */
      margin-bottom: 10px;
      transition: transform 0.5s ease; /* 平滑放大效果 */
    }

    .leader-card:hover {
      transform: scale(1.1); /* 鼠标悬停时放大1.1倍 */
    }

    .img {
      //box-shadow: 5px 5px 10px rgba(0, 0, 0, 0.5);
      /* 根据需要调整阴影的参数 */
    }

    .zhiWei {
      width: 12%;
      text-align: left;
      margin-left: 2vh
    }

    .name {
      font-size: 1.8vh;
      line-height: 2.3vh;
      font-weight: 500;
    }

    .leader-text {
      width: 75%;
      text-align: left;
      font-size: 2.2vh;
      line-height: 4vh;
      font-weight: 500;
      display: inline;
    }

    .tree ul {
      display: flex;
      margin: 0;
      padding: 20px 0 0;
      position: relative;
      transition: all 0.5s;
    }

    .tree li {
      position: relative;
      padding: 20px 5px 0;
      text-align: center;
      list-style-type: none;
      transition: all 0.5s;
      width: 100%;
    }

    .tree li::before,
    .tree li::after {
      position: absolute;
      top: 0;
      right: calc(50% - 1px);
      width: calc(50% + 1px);
      height: 20px;
      border-top: 2px solid #d9d7d7;
      content: '';
    }

    .tree li::after {
      right: auto;
      left: calc(50% - 1px);
      border-left: 2px solid #d9d7d7;
    }

    .tree li:only-child::after,
    .tree li:only-child::before {
      display: none;
    }

    .tree li:only-child {
      padding-top: 0;
    }

    .tree li:first-child::before,
    .tree li:last-child::after {
      border: 0 none;
    }

    .tree li:last-child::before {
      border-right: 2px solid #d9d7d7;
    }

    .tree ul ul::before {
      position: absolute;
      top: 0;
      left: calc(50% - 1px);
      width: 0;
      height: 20px;
      border-left: 2px solid #d9d7d7;
      content: '';
    }

    .leader1-box {
      position: relative;
      width: 20%;
      border-radius: 20px;
      display: inline-block;
      padding: 10px 10px;
      background-image: linear-gradient(to bottom right, #88A5DD, #4874CB);
      //border: 2px solid #999;
      text-decoration: none;
      color: #666;
      font-size: 12px;
      cursor: pointer;
      transition: all 0.5s;
      box-shadow: 5px 5px 10px rgba(0, 0, 0, 0.16);
    }

    .leader1-box p {
      line-height: 3vh;
      font-size: 2.2vh;
      color: #FBF0F2;
      font-weight: 530;
    }

    .leader1-box-title {
      position: absolute;
      top: -40px;
      left: 25%;
      font-size: 2.6vh;
      color: #4A74CB;
      //border: #fffefe;
    }

    .leader2-box-title {
      font-size: 2.2vh;
      color: #4A74CB;

    }

    .leader2-box {
      position: relative;
      width: 80%;
      border-radius: 20px;
      display: inline-block;
      padding: 10px 1vh;
      background-image: linear-gradient(to bottom right, #73DBD2, #30C0B4);
      //border: 2px solid #999;
      text-decoration: none;
      color: #4A74CB;
      cursor: pointer;
      transition: all 0.5s;
      box-shadow: 5px 5px 10px rgba(0, 0, 0, 0.16);
    }

    .leader2-box p {
      line-height: 3vh;
      font-size: 2.2vh;
      color: #FBF0F2;
      font-weight: 500;
    }

  }
}

@media only screen and (max-width: 800px) {
  .page {
    width: 100%;
    height: 100%;
    padding-left: 5%;
    padding-right: 5%;

    .text {
      //padding: 20px;
      text-indent: 2.4em;
      text-align: left;
      font-size: 0.8em;
      line-height: 2em;
      font-family: 微软雅黑;
      font-weight: 600;
    }

    .title {
      text-align: left;
      line-height: 1.5em;
      font-size: 2.5vh;
      font-weight: bold;
      margin-top: 60px;
    }

    .line {
      width: 100%;
      height: .6vh;
      margin: 0 auto;
      background: linear-gradient(to right,
      #678dda, /* 开始颜色 */ #6e6aec 50%, /* 在中心点附近使用过渡色 */ #678dda /* 结束颜色 */);
      margin-top: 1vh;
      margin-bottom: 1vh;
    }

    .leader-card {
      width: 100%;
      display: flex;
      border: #d5d7d7 1px solid;
      background-color: rgba(223, 224, 224, 0.29);
      padding: 5px;
      align-items: center; /* 垂直居中内容 */
      margin-bottom: 10px;
      transition: transform 0.5s ease; /* 平滑放大效果 */
    }

    .leader-card:hover {
      transform: scale(1.1); /* 鼠标悬停时放大1.1倍 */
    }

    .img {
      //box-shadow: 5px 5px 10px rgba(0, 0, 0, 0.5);
      /* 根据需要调整阴影的参数 */
    }

    .zhiWei {
      width: 25%;
      text-align: left;
      margin-left: 2vh
    }

    .name {
      font-size: 1.8vh;
      line-height: 2.3vh;
      font-weight: 500;
    }

    .leader-text {
      width: 50%;
      text-align: left;
      font-size: 14px;
      line-height: 20px;
      font-weight: 500;
    }

    .tree ul {
      display: flex;
      margin: 0;
      padding: 20px 0 0;
      position: relative;
      transition: all 0.5s;
    }

    .tree li {
      position: relative;
      padding: 20px 5px 0;
      text-align: center;
      list-style-type: none;
      transition: all 0.5s;
      width: 100%;
    }

    .tree li::before,
    .tree li::after {
      position: absolute;
      top: 0;
      right: calc(50% - 1px);
      width: calc(50% + 1px);
      height: 20px;
      border-top: 2px solid #d9d7d7;
      content: '';
    }

    .tree li::after {
      right: auto;
      left: calc(50% - 1px);
      border-left: 2px solid #d9d7d7;
    }

    .tree li:only-child::after,
    .tree li:only-child::before {
      display: none;
    }

    .tree li:only-child {
      padding-top: 0;
    }

    .tree li:first-child::before,
    .tree li:last-child::after {
      border: 0 none;
    }

    .tree li:last-child::before {
      border-right: 2px solid #d9d7d7;
    }

    .tree ul ul::before {
      position: absolute;
      top: 0;
      left: calc(50% - 1px);
      width: 0;
      height: 20px;
      border-left: 2px solid #d9d7d7;
      content: '';
    }

    .leader1-box {
      position: relative;
      width: 20%;
      border-radius: 20px;
      display: inline-block;
      padding: 10px 10px;
      background-image: linear-gradient(to bottom right, #88A5DD, #4874CB);
      //border: 2px solid #999;
      text-decoration: none;
      color: #666;
      font-size: 12px;
      cursor: pointer;
      transition: all 0.5s;
      box-shadow: 5px 5px 10px rgba(0, 0, 0, 0.16);
    }

    .leader1-box p {
      line-height: 3vh;
      font-size: 2.2vh;
      color: #FBF0F2;
      font-weight: 530;
    }

    .leader1-box-title {
      position: absolute;
      top: -40px;
      left: 25%;
      font-size: 2.6vh;
      color: #4A74CB;
      //border: #fffefe;
    }

    .leader2-box-title {
      font-size: 2.2vh;
      color: #4A74CB;

    }

    .leader2-box {
      position: relative;
      width: 80%;
      border-radius: 20px;
      display: inline-block;
      padding: 10px 1vh;
      background-image: linear-gradient(to bottom right, #73DBD2, #30C0B4);
      //border: 2px solid #999;
      text-decoration: none;
      color: #4A74CB;
      cursor: pointer;
      transition: all 0.5s;
      box-shadow: 5px 5px 10px rgba(0, 0, 0, 0.16);
    }

    .leader2-box p {
      line-height: 3vh;
      font-size: 2.2vh;
      color: #FBF0F2;
      font-weight: 500;
    }

  }
}
</style>



// WEBPACK FOOTER //
// src/components/page/organizationalStructure.vue